/**
 * Classifies Source Compare intake. The server re-parses and owns identity.
 * @param {unknown} raw
 * @returns {{ ok: true, kind: "pull" | "branch", label: string } | { ok: false, message: string }}
 */
export function parseCompareSourceInput(raw) {
  if (typeof raw !== "string" || !raw.trim()) {
    return {
      ok: false,
      message: "Paste a branch name, a GitHub /tree/ branch URL, or a pull request URL.",
    };
  }
  const s = raw.trim();
  if (
    /^(?:https?:\/\/)?(?:www\.)?github\.com\/[^/]+\/[^/]+\/pull\/\d+/i.test(s)
  ) {
    return { ok: true, kind: "pull", label: "pull request" };
  }
  if (
    /^(?:https?:\/\/)?(?:www\.)?github\.com\/[^/]+\/[^/]+\/tree\/.+/i.test(s)
  ) {
    return { ok: true, kind: "branch", label: "branch" };
  }
  if (/^https?:\/\//i.test(s) && !/github\.com/i.test(s)) {
    return {
      ok: false,
      message: "Only GitHub branch and pull request URLs are supported.",
    };
  }
  return { ok: true, kind: "branch", label: "branch" };
}
